export const workData = [
  {
    heading: "How Credit Card Balance Transfers Work in India",
    headDescription:
      "Managing high-interest credit card debt can be challenging. In India, several financial institutions offer solutions to help you manage and reduce this burden:",

    subheadOne: "Personal Loan on Credit Card (PLCC):",
    subheadOneList: [
      {
        heading: "Overview:",
        description:
          "Some banks provide pre-approved personal loans to their credit cardholders, allowing them to access funds at interest rates lower than standard credit card rates.",
      },
      {
        heading: "Benefits:",
        description:
          " These loans often come with flexible repayment tenures and fixed EMIs, making debt management more predictable.",
      },
      {
        heading: "Example: ",
        description:
          "HDFC Bank offers a ‘Loan on Credit Card’ facility, providing instant loans to cardholders with minimal documentation.",
      },
    ],
    subheadTwo: "Balance Transfer Products:",
    subheadTwoList: [
      {
        heading: "Overview:",
        description:
          "This facility enables you to transfer outstanding balances from one or multiple credit cards to another card with a lower interest rate.",
      },
      {
        heading: "Benefits:",
        description:
          " By consolidating debt under a single card with a lower rate, you can reduce overall interest expenses.",
      },
      {
        heading: "Example: ",
        description:
          "SBI Card offers a balance transfer option where you can transfer dues from other bank credit cards to an SBI Card at lower interest rates.",
      },
    ],
    subheadThree: "EMI Conversion Options:",
    subheadThreeList: [
      {
        heading: "Overview:",
        description:
          "Many banks allow you to convert your existing credit card dues into Equated Monthly Installments (EMIs).",
      },
      {
        heading: "Benefits:",
        description:
          " This approach breaks down your debt into manageable monthly payments, often at a lower interest rate than the standard credit card rate.",
      },
      {
        heading: "Example: ",
        description:
          " ICICI Bank provides an option to convert credit card transactions into EMIs, helping customers manage their finances better.",
      },
    ],

    headingTwo: "Key Considerations:",
    infoList: [
      {
        heading: "Interest Rates: ",
        description:
          "While these facilities offer lower rates than standard credit card charges, it’s essential to compare rates across different banks to ensure maximum savings.",
      },
      {
        heading: "Processing Fees:",
        description:
          " Be aware of any processing or transfer fees associated with these services, as they can impact overall savings.",
      },
      {
        heading: "Eligibility:",
        description:
          "  Banks may have specific eligibility criteria, such as a good credit score or a history of timely payments, to avail of these facilities.",
      },
    ],

    paraOne:
      "By exploring these options, you can choose a strategy that aligns with your financial goals and helps you manage credit card debt more effectively.",
  },
];

export const waysToPayOff = [
  {
    tableinfo:
      "Understanding the impact of your debt repayment strategy without utilizing a balance transfer can help you make informed financial decisions. Below is a table illustrating different scenarios with varying monthly payments and interest rates.",

    infoheading: "Key Insights:",

    infoList: [
      {
        info: "Higher Monthly Payments: ",
        description:
          " Opting for higher monthly payments can significantly reduce the total interest paid and shorten the repayment period.",
      },
      {
        info: "Extended Repayment Periods: ",
        description:
          " Lower monthly payments might seem manageable, but they result in a much higher total cost due to increased interest.",
      },
      {
        info: "High-Interest Rates:",
        description:
          " Managing debts with high APRs without a balance transfer can lead to substantial financial strain over time. Consider exploring balance transfer options to alleviate the interest burden.",
      },
    ],
    ways: "Ways to Pay Off Debt Faster",
    waysInfolist: [
      {
        info: "Increase Monthly Payments:",
        description:
          " Allocate more towards repayment to reduce interest and shorten the tenure.",
      },
      {
        info: "Consolidate Debt:",
        description:
          "Use Minemi’s balance transfer options to combine loans at a lower interest rate.",
      },
      {
        info: "Prioritize High-Interest Debts:",
        description: " Pay off the costliest debts first for better savings.",
      },
      {
        info: "Stick to a Budget:",
        description: "Allocate fixed amounts to repay debt consistently.",
      },
    ],
  },
];

export const costOfDebt = [
  {
    heading: "The cost of debt without a balance transfer",
    paraOne:
      "Carrying credit card debt without taking a balance transfer can significantly increase the total cost of repayment. To help you understand this better, we’ve developed a calculator that shows the monthly payment required to pay off your debt within a given timeframe.",

    paraTwo:
      "It’s important to note that paying off debt is not as simple as dividing the principal amount by the number of months in the repayment period. For example, if you have ₹1,00,000 in debt and plan to pay ₹10,000 per month over 10 months, you will still owe more because of the added interest. At an interest rate of 16%, you’d need to pay approximately ₹10,700 per month to completely clear the debt within 10 months.",

    paraThree:
      "With the calculator below, you can input your credit card balance, interest rate, and repayment period to receive insights into:",

    infoList: [
      {
        info: ".Required Monthly Payment: ",
        description:
          "The exact amount needed to eliminate the debt in your desired timeframe.",
      },
      {
        info: "Total Interest Paid: ",
        description: " The cumulative interest cost over the repayment period.",
      },
      {
        info: "Total Amount to Be Paid:",
        description: "The overall cost, including the principal and interest.",
      },
    ],
  },
];
